import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project-imports
import Loadable from "components/Loadable";
import DashboardLayout from "layout/Admin";

const MaintenanceError = Loadable(
  lazy(() => import("pages/admin/maintenance/error/404")),
);

/* -------------------------------------------------------------------------- */
/*                                  DASHBOARD                                 */
/* -------------------------------------------------------------------------- */
const Dashboard = Loadable(lazy(() => import("pages/admin/dashboard/page")));

/* -------------------------------------------------------------------------- */
/*                                   USERS                                    */
/* -------------------------------------------------------------------------- */
const ListUsers = Loadable(lazy(() => import("pages/admin/users/list")));
const UserProfile = Loadable(lazy(() => import("pages/admin/users/profile")));
const RoleGenerate = Loadable(lazy(() => import("pages/admin/roles/generate")));
const SubAdminLogs = Loadable(lazy(() => import("pages/admin/roles/logs")));

/* -------------------------------------------------------------------------- */
/*                                   NOTES                                    */
/* -------------------------------------------------------------------------- */
const AddNote = Loadable(lazy(() => import("pages/admin/notes/add")));
const ListNotes = Loadable(lazy(() => import("pages/admin/notes/list")));
const EditNote = Loadable(lazy(() => import("pages/admin/notes/edit")));

/* -------------------------------------------------------------------------- */
/*                                    Avis                                    */
/* -------------------------------------------------------------------------- */
const AddAvis = Loadable(lazy(() => import("pages/admin/avis/add")));
const ListAvis = Loadable(lazy(() => import("pages/admin/avis/list")));
const EditAvis = Loadable(lazy(() => import("pages/admin/avis/edit")));

/* -------------------------------------------------------------------------- */
/*                                 ACTUALITÉS                                 */
/* -------------------------------------------------------------------------- */
const AddActualite = Loadable(lazy(() => import("pages/admin/actualites/add")));
const ListActualites = Loadable(
  lazy(() => import("pages/admin/actualites/list")),
);
const EditActualite = Loadable(
  lazy(() => import("pages/admin/actualites/edit")),
);

/* -------------------------------------------------------------------------- */
/*                                   EVENTS                                   */
/* -------------------------------------------------------------------------- */
const AddEvent = Loadable(lazy(() => import("pages/admin/events/add")));
const ListEvents = Loadable(lazy(() => import("pages/admin/events/list")));
const EditEvent = Loadable(lazy(() => import("pages/admin/events/edit")));

/* -------------------------------------------------------------------------- */
/*                                   EXPERTS                                  */
/* -------------------------------------------------------------------------- */
const AddExpert = Loadable(lazy(() => import("pages/admin/experts/add")));
const ListExperts = Loadable(lazy(() => import("pages/admin/experts/list")));
const EditExpert = Loadable(lazy(() => import("pages/admin/experts/edit")));

/* -------------------------------------------------------------------------- */
/*                                INSTITUTIONS                                */
/* -------------------------------------------------------------------------- */
const AddInstitu = Loadable(lazy(() => import("pages/admin/institutions/add")));
const ListInstitus = Loadable(
  lazy(() => import("pages/admin/institutions/list")),
);
const EditInstitu = Loadable(
  lazy(() => import("pages/admin/institutions/edit")),
);

/* -------------------------------------------------------------------------- */
/*                         PROGRAMMES (TAMWIL)                                */
/* -------------------------------------------------------------------------- */
const AddProgramme = Loadable(
  lazy(() => import("pages/admin/programmes/add")),
);
const ListProgrammes = Loadable(
  lazy(() => import("pages/admin/programmes/list")),
);

/* -------------------------------------------------------------------------- */
/*                                NOTIFICATION                                */
/* -------------------------------------------------------------------------- */
const Notifications = Loadable(lazy(() => import("pages/admin/notifications")));
const ContributionDetail = Loadable(
  lazy(() => import("pages/admin/contributions/[id]")),
);
const ReportDetail = Loadable(lazy(() => import("pages/admin/reports/[id]")));

/* -------------------------------------------------------------------------- */
/*                                    TAGS                                    */
/* -------------------------------------------------------------------------- */
const Tags = Loadable(lazy(() => import("pages/admin/tags")));

/* -------------------------------------------------------------------------- */
/*                                   SOURCES                                  */
/* -------------------------------------------------------------------------- */
const ListSources = Loadable(lazy(() => import("pages/admin/sources/list")));
const AddSource = Loadable(lazy(() => import("pages/admin/sources/add")));
const EditSource = Loadable(lazy(() => import("pages/admin/sources/edit")));
const CategoriesList = Loadable(
  lazy(() => import("pages/admin/tags/categories")),
);
const ProfessionsList = Loadable(
  lazy(() => import("pages/admin/tags/professions")),
);
const KeywordsList = Loadable(lazy(() => import("pages/admin/tags/keywords")));
const OrganizationTypesList = Loadable(
  lazy(() => import("pages/admin/tags/organization-types")),
);
const ProgrammeSectorsList = Loadable(
  lazy(() => import("pages/admin/tags/programme-sectors")),
);
const ProgrammeActivitiesList = Loadable(
  lazy(() => import("pages/admin/tags/programme-activities")),
);
const ProgrammeFinancingNeedsList = Loadable(
  lazy(() => import("pages/admin/tags/programme-financing-needs")),
);
const ProgrammeFinancingTypesList = Loadable(
  lazy(() => import("pages/admin/tags/programme-financing-types")),
);
const FormationCategoriesList = Loadable(
  lazy(() => import("pages/admin/tags/formation-categories")),
);
const EventTypesList = Loadable(
  lazy(() => import("pages/admin/tags/event-types")),
);
const BlogCategoriesList = Loadable(
  lazy(() => import("pages/admin/tags/blog-categories")),
);
const SourceLevels = Loadable(lazy(() => import("pages/admin/source-levels")));

/* -------------------------------------------------------------------------- */
/*                              FORMATION MANAGEMENT                          */
/* -------------------------------------------------------------------------- */
const AddFormation = Loadable(lazy(() => import("pages/admin/formations/add")));
const ListFormations = Loadable(
  lazy(() => import("pages/admin/formations/list")),
);
const EditFormation = Loadable(
  lazy(() => import("pages/admin/formations/edit")),
);

/* -------------------------------------------------------------------------- */
/*                               MODULE MANAGEMENT                           */
/* -------------------------------------------------------------------------- */
const ListModules = Loadable(lazy(() => import("pages/admin/modules/list")));
const EditModule = Loadable(lazy(() => import("pages/admin/modules/edit")));

/* -------------------------------------------------------------------------- */
/*                              CERTIFICATIONS                               */
/* -------------------------------------------------------------------------- */
const ListCertificats = Loadable(
  lazy(() => import("pages/admin/certifications/list")),
);
const AddCertificate = Loadable(
  lazy(() => import("pages/admin/certifications/add")),
);
const EditCertificate = Loadable(
  lazy(() => import("pages/admin/certifications/edit")),
);

/* -------------------------------------------------------------------------- */
/*                               GAMIFICATION                                 */
/* -------------------------------------------------------------------------- */
const Gamification = Loadable(lazy(() => import("pages/admin/gamification")));
const VeilleCategory = Loadable(
  lazy(() => import("pages/admin/gamification/category/veille")),
);
const ApprentissageCategory = Loadable(
  lazy(() => import("pages/admin/gamification/category/apprentissage")),
);
const CommunauteCategory = Loadable(
  lazy(() => import("pages/admin/gamification/category/communaute")),
);
const InformationsCategory = Loadable(
  lazy(() => import("pages/admin/gamification/category/informations")),
);
const BadgesManagement = Loadable(
  lazy(() => import("pages/admin/gamification/badges")),
);

/* -------------------------------------------------------------------------- */
/*                                 CORPORATE                                  */
/* -------------------------------------------------------------------------- */
const Corporate = Loadable(lazy(() => import("pages/admin/corporate")));
const HeroManagement = Loadable(
  lazy(() => import("pages/admin/heromanagement")),
);
const Waitlist = Loadable(lazy(() => import("pages/admin/waitlist")));

/* -------------------------------------------------------------------------- */
/*                                 INSIGHTS                                   */
/* -------------------------------------------------------------------------- */
const Insights = Loadable(lazy(() => import("pages/admin/insights")));
const AddInsight = Loadable(lazy(() => import("pages/admin/insights/add")));
const ListInsights = Loadable(lazy(() => import("pages/admin/insights/list")));
const EditInsight = Loadable(lazy(() => import("pages/admin/insights/edit")));
const InsightCategories = Loadable(
  lazy(() => import("pages/admin/insights/categories")),
);
const HeroInsightsManagement = Loadable(
  lazy(() => import("pages/admin/hero-insights-management")),
);

/* -------------------------------------------------------------------------- */
/*                                 ASSISTANCE                                 */
/* -------------------------------------------------------------------------- */
const Assistance = Loadable(lazy(() => import("pages/admin/assistance")));
const VideosList = Loadable(
  lazy(() => import("pages/admin/assistance/videos/list")),
);
const SectionsList = Loadable(
  lazy(() => import("pages/admin/assistance/sections/list")),
);
const ActualiteAssistanceAdd = Loadable(
  lazy(() => import("pages/admin/assistance/actualites/add")),
);
const ActualiteAssistanceEdit = Loadable(
  lazy(() => import("pages/admin/assistance/actualites/edit")),
);
const AssistanceItemsList = Loadable(
  lazy(() => import("pages/admin/assistance/actualites/list")),
);
const SupportContactsList = Loadable(
  lazy(() => import("pages/admin/assistance/support-contacts/list")),
);

/* -------------------------------------------------------------------------- */
/*                                 NEWSLETTERS                                */
/* -------------------------------------------------------------------------- */
const NewsletterDashboard = Loadable(
  lazy(() => import("pages/admin/newsletters/NewsletterDashboard")),
);
const NewsletterCreate = Loadable(
  lazy(() => import("pages/admin/newsletters/NewsletterCreate")),
);
const NewsletterAnalytics = Loadable(
  lazy(() => import("pages/admin/newsletters/NewsletterAnalytics")),
);
const NewsletterSubscribers = Loadable(
  lazy(() => import("pages/admin/newsletter/NewsletterAdmin")),
);

/* -------------------------------------------------------------------------- */
/*                                  LIBRARY                                  */
/* -------------------------------------------------------------------------- */
const AddLibrary = Loadable(lazy(() => import("pages/admin/library/add")));
const ListLibrary = Loadable(lazy(() => import("pages/admin/library/list")));
const EditLibrary = Loadable(lazy(() => import("pages/admin/library/edit")));
const LibraryCategoriesList = Loadable(
  lazy(() => import("pages/admin/tags/library-categories")),
);

const ListBanners = Loadable(lazy(() => import("pages/admin/banners/list")));
const ContributionsOverview = Loadable(lazy(() => import("pages/admin/contributions/index")));
const ContributionModerationHub = Loadable(
  lazy(() => import("pages/admin/contributions/ContributionModerationHub")),
);

const AddBanner = Loadable(lazy(() => import("pages/admin/banners/add")));

const EditBanner = Loadable(lazy(() => import("pages/admin/banners/edit")));

// ==============================|| MAIN ROUTES ||============================== //

const AdminRoutes = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "admin",
      children: [
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "add-note",
          element: <AddNote />,
        },
        {
          path: "list-notes",
          element: <ListNotes />,
        },
        {
          path: "list-users",
          element: <ListUsers />,
        },
        {
          path: "role-generate",
          element: <RoleGenerate />,
        },
        {
          path: "sub-admin-logs",
          element: <SubAdminLogs />,
        },
        {
          path: "users/profile/:id",
          element: <UserProfile />,
        },
        {
          path: "edit-note/:id",
          element: <EditNote />,
        },
        {
          path: "add-avis",
          element: <AddAvis />,
        },
        {
          path: "list-avis",
          element: <ListAvis />,
        },
        {
          path: "edit-avis/:id",
          element: <EditAvis />,
        },
        {
          path: "list-blogs",
          element: <ListActualites />,
        },
        {
          path: "add-blog",
          element: <AddActualite />,
        },
        {
          path: "edit-blog/:id",
          element: <EditActualite />,
        },
        {
          path: "add-insight",
          element: <AddInsight />,
        },
        {
          path: "list-insights",
          element: <ListInsights />,
        },
        {
          path: "edit-insight/:id",
          element: <EditInsight />,
        },
        {
          path: "insight-categories",
          element: <InsightCategories />,
        },
        {
          path: "add-event",
          element: <AddEvent />,
        },
        {
          path: "list-events",
          element: <ListEvents />,
        },
        {
          path: "edit-event/:id",
          element: <EditEvent />,
        },
        {
          path: "add-expert",
          element: <AddExpert />,
        },
        {
          path: "list-experts",
          element: <ListExperts />,
        },
        {
          path: "edit-expert/:id",
          element: <EditExpert />,
        },
        {
          path: "add-institution",
          element: <AddInstitu />,
        },
        {
          path: "list-institutions",
          element: <ListInstitus />,
        },
        {
          path: "edit-institution/:id",
          element: <EditInstitu />,
        },
        {
          path: "add-programme",
          element: <AddProgramme />,
        },
        {
          path: "edit-programme/:id",
          element: <AddProgramme />,
        },
        {
          path: "list-programmes",
          element: <ListProgrammes />,
        },
        {
          path: "tags",
          element: <Tags />,
        },
        {
          path: "list-sources",
          element: <ListSources />,
        },
        {
          path: "add-source",
          element: <AddSource />,
        },
        {
          path: "edit-source/:id",
          element: <EditSource />,
        },
        // Tag Management Routes
        {
          path: "tags/categories",
          element: <CategoriesList />,
        },
        {
          path: "tags/professions",
          element: <ProfessionsList />,
        },
        {
          path: "tags/keywords",
          element: <KeywordsList />,
        },
        {
          path: "tags/organization-types",
          element: <OrganizationTypesList />,
        },
        {
          path: "tags/programme-sectors",
          element: <ProgrammeSectorsList />,
        },
        {
          path: "tags/programme-activities",
          element: <ProgrammeActivitiesList />,
        },
        {
          path: "tags/programme-financing-needs",
          element: <ProgrammeFinancingNeedsList />,
        },
        {
          path: "tags/programme-financing-types",
          element: <ProgrammeFinancingTypesList />,
        },
        {
          path: "tags/formation-categories",
          element: <FormationCategoriesList />,
        },
        {
          path: "tags/event-types",
          element: <EventTypesList />,
        },
        {
          path: "tags/blog-categories",
          element: <BlogCategoriesList />,
        },
        {
          path: "source-levels",
          element: <SourceLevels />,
        },
        {
          path: "add-formation",
          element: <AddFormation />,
        },
        {
          path: "list-formations",
          element: <ListFormations />,
        },
        {
          path: "edit-formation/:id",
          element: <EditFormation />,
        },
        {
          path: "add-module",
          element: <Navigate to="/admin/list-modules" replace />,
        },
        {
          path: "list-modules",
          element: <ListModules />,
        },
        {
          path: "edit-module/:id",
          element: <EditModule />,
        },
        {
          path: "list-certificates",
          element: <ListCertificats />,
        },
        {
          path: "add-certificate",
          element: <AddCertificate />,
        },
        {
          path: "edit-certificate/:id",
          element: <EditCertificate />,
        },
        {
          path: "notifications",
          element: <Notifications />,
        },
        {
          path: "contributions/moderate/:type",
          element: <ContributionModerationHub />,
        },
        {
          path: "contributions/:id",
          element: <ContributionDetail />,
        },
        {
          path: "reports/:id",
          element: <ReportDetail />,
        },
        // Newsletter Management Routes
        {
          path: "newsletters",
          element: <NewsletterDashboard />,
        },
        {
          path: "newsletters/create",
          element: <NewsletterCreate />,
        },
        {
          path: "newsletters/:id/edit",
          element: <NewsletterCreate />,
        },
        {
          path: "newsletters/:id/analytics",
          element: <NewsletterAnalytics />,
        },
        {
          path: "newsletters/subscribers",
          element: <NewsletterSubscribers />,
        },
        // Library Management Routes
        {
          path: "add-library",
          element: <AddLibrary />,
        },
        {
          path: "list-library",
          element: <ListLibrary />,
        },
        {
          path: "edit-library/:id",
          element: <EditLibrary />,
        },
        {
          path: "tags/library-categories",
          element: <LibraryCategoriesList />,
        },
        // Banner Management Routes
        {
          path: "list-banners",
          element: <ListBanners />,
        },
        {
          path: "add-banner",
          element: <AddBanner />,
        },
        {
          path: "edit-banner/:id",
          element: <EditBanner />,
        },
        // Gamification Routes
        {
          path: "gamification",
          element: <Gamification />,
        },
        {
          path: "gamification/category/veille",
          element: <VeilleCategory />,
        },
        {
          path: "gamification/category/apprentissage",
          element: <ApprentissageCategory />,
        },
        {
          path: "gamification/category/communaute",
          element: <CommunauteCategory />,
        },
        {
          path: "gamification/category/informations",
          element: <InformationsCategory />,
        },
        {
          path: "gamification/badges",
          element: <BadgesManagement />,
        },
        // Corporate Routes
        {
          path: "corporate",
          element: <Corporate />,
        },
        // Waitlist Routes
        {
          path: "waitlist",
          element: <Waitlist />,
        },
        // Hero Management Routes
        {
          path: "heromanagement",
          element: <HeroManagement />,
        },
        // Insights Routes
        {
          path: "insights",
          element: <Insights />,
        },
        // Hero Insights Management Routes
        {
          path: "hero-insights-management",
          element: <HeroInsightsManagement />,
        },
        // Assistance Routes
        {
          path: "assistance",
          element: <Assistance />,
        },
        {
          path: "assistance/videos",
          element: <VideosList />,
        },
        {
          path: "assistance/sections",
          element: <SectionsList />,
        },
        {
          path: "assistance/actualites/add",
          element: <ActualiteAssistanceAdd />,
        },
        {
          path: "assistance/actualites",
          element: <AssistanceItemsList />,
        },
        {
          path: "assistance/actualites/:id/edit",
          element: <ActualiteAssistanceEdit />,
        },
        {
          path: "assistance/support-contacts",
          element: <SupportContactsList />,
        },
        {
          path: "contributions",
          element: <ContributionsOverview />,
        },
      ],
    },
    {
      path: "*",
      element: <MaintenanceError />,
    },
  ],
};

export default AdminRoutes;
